import { render } from "./dragdrop.vue?vue&type=template&id=dc2a7398&scoped=true"
import script from "./dragdrop.vue?vue&type=script&lang=js"
export * from "./dragdrop.vue?vue&type=script&lang=js"

import "./dragdrop.vue?vue&type=style&index=0&id=dc2a7398&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2a7398"]])

export default __exports__